import React, { Component } from "react";
import classes from "./interview.module.css";
import { Modal, Row, Col, Image, Form, Button } from "react-bootstrap";
import user from "../../Assets/Images/user.jpg";
import cv from "../../Assets/icons/1x/cvmdpi.png";
import star from "../../Assets/icons/1x/rating starmdpi.png";
import moment from "moment";
import Servererror from "../commonComponents/NetworkError/ServerError/Servererror";
import { connect } from "react-redux";
import * as actionTypes from "../../Action/Index";
import Loader from "react-loader-advanced";
import Spinner from "react-bootstrap/Spinner";
import recommend from "../../Assets/icons/3x/Bigxxhdpi.png";

class interviewProfileView extends Component {
  state = {
    skillBox: "hidden",
    skillBoxOpicity: "0",
    profileData: "",
    rating: 0,
    cvData: null,
  };

  displaySkillBox = async () => {
    let arr = [];
    if (this.state.skillBox === "hidden") {
      this.setState({
        skillBox: "visible",
        skillBoxOpicity: "1",
      });
    } else {
      this.setState({
        skillBox: "hidden",
        skillBoxOpicity: "0",
        rating: 0,
      });
      await this.props.interviewerRating(this.props.email, this.state.rating);
      await this.props.getInterviewerProfile(this.props.email, this.props.id);
      await this.props.externalInterviewerList(1, arr);
    }
  };

  ratingChanged = (new_rating) => {
    this.setState({
      rating: new_rating,
    });
  };
  componentDidMount = () => {
    this.props.getInterviewerProfile(this.props.email, this.props.id);
  };
  componentWillReceiveProps(nextProps) {
    if (nextProps.interviewerProfileData !== null) {
      this.setState({ profileData: nextProps.interviewerProfileData });
    }
    if (nextProps.cvData !== this.state.cvData) {
      this.setState({ cvData: nextProps.cvData });
    }
  }

  render() {
    let sklList = "";
    let timeslot = [];

    if (this.state.profileData.skillList !== undefined) {
      sklList += this.state.profileData.skillList.map(
        (index) => " " + index.value
      );
    }

    if (
      this.state.profileData.timeSlotResponse !== undefined &&
      this.state.profileData.timeSlotResponse != null
    ) {
      timeslot = this.state.profileData.timeSlotResponse.map((ind) => {
        return (
          <span className={classes.userDetails}>
            {ind.dayType}(
            {moment("10-10-1029 " + ind.startTime).format("h:mm a")}-
            {moment("10-10-1029 " + ind.endTime).format("h:mm a")})
          </span>
        );
      });
    }
    return (
      <>
        <Modal
          id="Dialogid"
          show={this.props.show}
          onHide={this.props.handleClose}
          backdrop="false"
          centered={true}
        >
          <Loader
            show={this.props.loader}
            message={<Spinner animation="border" role="status"></Spinner>}
            style={{ height: "auto" }}
            foregroundStyle={{ color: "#fbb03b" }}
            backgroundStyle={{ backgroundColor: "#F3EFEF" }}
          >
            {this.props.getApiStatus === true ? (
              <>
                <Modal.Body>
                  <Row>
                    <Col lg={1} md={1}>
                      {this.state.profileData.recommendation != undefined &&
                      this.state.profileData.recommendation != null &&
                      this.state.profileData.recommendation != "" ? (
                        <div>
                          <img
                            title={this.state.profileData.recommendation}
                            style={{
                              position: "relative",
                              top: "-27px",
                              left: "-29px",
                            }}
                            type="image/svg+xml"
                            width="33px"
                            src={recommend}
                            alt="search"
                          />
                        </div>
                      ) : null}
                    </Col>
                    <Col lg={10} md={10}></Col>
                    <Col lg={1} md={1}>
                      <div
                        className={classes.modalClose}
                        onClick={() => {
                          this.props.handleClose();
                          this.setState({
                            skillBox: "hidden",
                            skillBoxOpicity: "0",
                            rating: 0,
                          });
                        }}
                      >
                        <i className={`fa fa-times-circle`}> </i>{" "}
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <Row>
                        <Col md={4} xs={12} sm={4} lg={4}>
                          <Image
                            src={this.props.image}
                            roundedCircle
                            width={120}
                            height={120}
                          />
                        </Col>
                        <Col md={8}>
                          <Row>
                            <Col md={12}>
                              {this.state.profileData.averageInterviewerRating >
                              0 ? (
                                <div
                                  className={`float-right ${classes.marginRight}`}
                                >
                                  <div className={classes.skillset}>
                                    {this.state.profileData
                                      .totalInterviewTaken > 0 ? (
                                      <span>
                                        {
                                          this.state.profileData
                                            .totalInterviewTaken
                                        }
                                        + Interviews{" "}
                                      </span>
                                    ) : null}
                                    <span className="font-weight-bold">
                                      {
                                        this.state.profileData
                                          .averageInterviewerRating
                                      }{" "}
                                    </span>
                                    <img
                                      type="image/svg+xml"
                                      src={star}
                                      className={`${classes.star}`}
                                    />{" "}
                                  </div>{" "}
                                </div>
                              ) : (
                                <span
                                  className={`float-right ${classes.marginRight}`}
                                >
                                  No rating available
                                </span>
                              )}
                            </Col>

                            <Col md={12} className={classes.userInfo}>
                              <h5>
                                <strong>{this.state.profileData.name}</strong>
                              </h5>
                              <span>
                                {this.state.profileData.positionTitle}
                              </span>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <br />
                      <Row>
                        <Col md={10} xs={10} sm={10} lg={10}>
                          <Row>
                            <Col md={4} xs={5} sm={4} lg={4}>
                              <span
                                className={`text-right ${classes.detailLabel}`}
                              >
                                Skills:
                              </span>
                            </Col>
                            <Col md={8} xs={12} sm={8} lg={8}>
                              <span className={classes.userDetails}>
                                {sklList == ""
                                  ? "Skill not available"
                                  : sklList}
                              </span>
                            </Col>
                          </Row>
                          <Row>
                            <Col md={4} xs={5} sm={4} lg={4}>
                              <span
                                className={`text-right ${classes.detailLabel}`}
                              >
                                Experience:
                              </span>
                            </Col>
                            <Col md={8} xs={12} sm={8} lg={8}>
                              <span className={classes.userDetails}>
                                {this.state.profileData.experienceInYear}
                                {this.state.profileData.experienceInYear > 1
                                  ? " years "
                                  : " year "}
                                {this.state.profileData.experienceInMonth}
                                {this.state.profileData.experienceInMonth > 1
                                  ? " months"
                                  : " month"}
                              </span>
                            </Col>
                          </Row>
                          {/* <Row>
                            <Col md={4} xs={5} sm={4} lg={4}><span className={`text-right ${classes.detailLabel}`}>Email ID:</span></Col>
                            <Col md={8} xs={12} sm={8} lg={8}><span className={classes.userDetails}>{this.state.profileData.email}</span></Col>
                            </Row> */}
                          {/* <Row>
                                <Col md={4} xs={5} sm={4} lg={4}><span className={`text-right ${classes.detailLabel}`}>Contact:</span></Col>
                                <Col md={8} xs={12} sm={8} lg={8}><span className={classes.userDetails}>{this.state.profileData.mobile}</span></Col>
                            </Row> */}
                          <Row>
                            <Col md={4} xs={5} sm={4} lg={4}>
                              <span
                                className={`text-right ${classes.detailLabel}`}
                              >
                                Availability:
                              </span>
                            </Col>
                            <Col md={8} xs={12} sm={8} lg={8}>
                              {timeslot.length === 0 ? (
                                <span>Not available</span>
                              ) : (
                                timeslot
                              )}
                            </Col>
                          </Row>
                          <Row>
                            <Col md={4} xs={5} sm={4} lg={4}>
                              <span
                                className={`text-right ${classes.detailLabel}`}
                              >
                                Location:
                              </span>
                            </Col>
                            <Col md={8} xs={12} sm={8} lg={8}>
                              <span className={classes.userDetails}>
                                {this.state.profileData.location === null
                                  ? "Location not available"
                                  : this.state.profileData.location}
                              </span>
                            </Col>
                          </Row>
                          {/* <Row>
                                <Col md={4} xs={5} sm={4} lg={4}><span className={`text-right ${classes.detailLabel}`}>Skype ID:</span></Col>
                                <Col md={8} xs={12} sm={8} lg={8}><span className={classes.userDetails}>{this.state.profileData.skypeId===null?"Skype ID not available":this.state.profileData.skypeId}</span></Col>
                            </Row> */}
                        </Col>
                        <Col md={2} xs={2} sm={2} lg={2}>
                          <br />
                          {/* <a href={this.state.cvData} className={classes.viewCV}><Image src={cv}  width={100} thumbnail={true} className="float-right" />
                        <small  className={classes.viewCV} style={this.state.cvData!==null?{color:"black"}:{color:"grey"}}>View CV</small></a> */}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Modal.Body>
              </>
            ) : (
              <Servererror
                msg={this.props.errorMsg}
                marginTop="17%"
                width="35%"
              />
            )}
          </Loader>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    getApiStatus: state.employeeReducer.interviewerProfileStatus,
    interviewerProfileData: state.employeeReducer.interviewerProfileData,
    loader: state.employeeReducer.interviewerProfileLoader,
    errorMsg: state.employeeReducer.interviewerProfileErrorMsg,
    saveInterviewerRatingLoader:
      state.employeeReducer.saveInterviewerRatingLoader,
    saveInterviewerRatingStatus:
      state.employeeReducer.saveInterviewerRatingStatus,
    saveInterviewerRatingErrorMsg:
      state.employeeReducer.saveInterviewerRatingErrorMsgstate,
    openCvLoader: state.employeeReducer.openCvLoader,
    openCvStatus: state.employeeReducer.openCvStatus,
    openCvErrorMsg: state.employeeReducer.openCvErrorMsg,
    openCvSuggestion: state.employeeReducer.openCvSuggestion,
    cvData: state.employeeReducer.cvData,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getInterviewerProfile: (email, id) =>
      dispatch(actionTypes.getInterviewerProfile(email, id)),
    interviewerRating: (email, rating) =>
      dispatch(actionTypes.saveInterviewerRating(email, rating)),
    externalInterviewerList: (page, searchArray) =>
      dispatch(actionTypes.getExtInterviewerList(page, searchArray)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(interviewProfileView);
